import React, { Component } from "react";
import {
  View,
  StyleSheet,
  Dimensions,
  TouchableHighlight,
} from "react-native";
import Text from "../components_v2/TextFont";
import PersianCalendarPicker from "react-native-persian-calendar-picker";

import ArTheme from "../argon-ui/Theme";
import {
  faCalendar,
} from "../../assets/consts/faCharCodes";
import { translate } from "../locales/translate";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import Select from "../nativeBase-ui/Select";
import ModalBase from "../nativeBase-ui/ModalBase";

let moment = require("moment-jalaali");
const SCREEN_WIDTH = Dimensions.get("window").width;
class DateAndTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCalenderModal: false,
      startTimes: [],
      endTimes: [],
      startTime:
        this.props.minHour > 10
          ? `${this.props.minHour}:00`
          : `0${this.props.minHour}:00`,
      endTime:
        this.props.minHour > 10
          ? `${this.props.minHour}:59`
          : `0${this.props.minHour}:59`,
      pDateDesired: null,
    };
    this.onDateChange = this.onDateChange.bind(this);
  }
  componentDidMount() {
    this.onDateChange(new Date());
    this.props.selectedStartTime(this.state.startTime);
    this.props.selectedEndTime(this.state.endTime);
    this.props.selectedDate(this.state.pDateDesired);
    this.createTime();
  }
  hideModal = () => {
    this.setState({ showCalenderModal: false });
  };
  formatDate = (date) => {
    var dateSeperated = date.split("/");
    var yy = dateSeperated[0];
    var mm =
      parseInt(dateSeperated[1]) < 10
        ? `0${dateSeperated[1]}`
        : dateSeperated[1];
    var dd =
      parseInt(dateSeperated[2]) < 10
        ? `0${dateSeperated[2]}`
        : dateSeperated[2];
    date = yy + "/" + mm + "/" + dd;
    return date;
  };
  onDateChange(date) {
    date = this.formatDate(moment(date).format("jYYYY/jM/jD"));
    this.setState({ pDateDesired: date }, () => {
      this.props.selectedDate && this.props.selectedDate(date);
    });
    this.hideModal();
    return;
  }
  handelOnSelectStartTime = (startTime) => {
    this.setState({ startTime: startTime }, () => {
      this.props.selectedStartTime && this.props.selectedStartTime(startTime);
      startTime = parseInt(startTime.split(":")[0]);
      var endTime = parseInt(this.state.endTime.split(":")[0]);
      if (startTime > endTime) {
        this.handelOnSelectEndTime(
          startTime > 10 ? `${startTime}:59` : `0${startTime}:59`
        );
      }
      this.createEndTime(startTime);
    });
  };
  handelOnSelectEndTime = (endTime) => {
    this.setState({ endTime: endTime }, () => {
      this.props.selectedEndTime && this.props.selectedEndTime(endTime);
    });
  };
  createTime(startTime = null, endTime = null) {
    this.createEndTime();
    this.createStartTime();
  }
  createEndTime(endTimeValid = null) {
    let endTime = endTimeValid || this.props.minHour;
    let endTimes = [];
    try {
      while (endTime <= this.props.maxHour - 1) {
        endTimes.push(
          endTime < 10
            ? { label: `0${endTime}:59`, value: `0${endTime}:59` }
            : { label: `${endTime}:59`, value: `${endTime}:59` }
        );
        endTime += 1;
      }
    } catch (err) {
      console.log("error in DateAndTime component end Time", err);
    }
    this.setState({ endTimes });
  }
  createStartTime(startTimeStart = null) {
    let startTime = startTimeStart || this.props.minHour;
    let startTimes = [];
    try {
      while (startTime <= this.props.maxHour - 1) {
        startTimes.push(
          startTime < 10
            ? { label: `0${startTime}:00`, value: `0${startTime}:00` }
            : { label: `${startTime}:00`, value: `${startTime}:00` }
        );
        startTime += 1;
      }
    } catch (err) {
      console.log("error in DateAndTime component start Time", err);
    }
    this.setState({ startTimes });
  }
  render() {
    return (
      <View style={this.props.rootStyle || styles.rootStyle}>
        {/* show calender */}
        <View style={this.props.calenderStyle || styles.calenderStyle}>
          <TouchableHighlight
            onPress={() => {
              this.setState({ showCalenderModal: true });
            }}
            underlayColor={ArTheme.COLORS.BORDER}
            style={{
              borderColor: ArTheme.COLORS.BORDER,
              borderWidth: 1,
              borderRadius: 4,
              backgroundColor: "#FFFFFF",
              shadowColor: ArTheme.COLORS.BLACK,
              shadowOffset: { width: 0, height: 1 },
              shadowRadius: 2,
              shadowOpacity: 0.05,
              elevation: 2,
              paddingStart: 5,
              paddingEnd: 10,
              marginTop: 20,
              height: 45,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                padding: 10,
              }}
            >
              <FontAwesomeIcon icon={faCalendar} color="gray" size={20} />
              <Text
                style={{
                  paddingEnd: 6,
                  fontFamily: "IRANSansWebFaNum",
                  fontSize: 13,
                  alignItems: "flex-start",
                  paddingStart: 12,
                }}
              >
                {this.state.pDateDesired}
              </Text>
            </View>
          </TouchableHighlight>
          {/* calender */}
          <ModalBase
            avoidKeyboard={true}
            isOpen={this.state.showCalenderModal}
            onClose={() => this.hideModal()}
          >
            <View
              style={{
                justifyContent: "center",
                backgroundColor: "#fff",
                alignItems: "center",
                borderRadius: 5,
                marginTop: 50,
                marginEnd: 3,
                padding: 10,
              }}
            >
              <PersianCalendarPicker
                textStyle={{ fontFamily: "IRANSansWebFaNum" }}
                minDate={new Date().toLocaleDateString("fa-IR")}
                onDateChange={this.onDateChange}
                selectedDayColor="blue"
                scaleFactor={SCREEN_WIDTH * 1.1}
              ></PersianCalendarPicker>
            </View>
          </ModalBase>
        </View>
        {/* show time from */}
        <View style={styles.timerStyle}>
          <Text style={{ marginStart: 13, marginEnd: 5, paddingTop: 10 }}>
            {translate("api.timeFrom")}
          </Text>
          <Select
            label={null}
            data={this.state.startTimes}
            value={this.state.startTime}
            onChangeText={(value, index, data) => {
              this.handelOnSelectStartTime(value);
            }}
          ></Select>
        </View>
        {/* show time to */}
        <View style={styles.timerStyle}>
          <Text style={{ marginStart: 13, marginEnd: 5, paddingTop: 10 }}>
            {translate("api.timeTo")}
          </Text>
          <Select
            label={null}
            data={this.state.endTimes}
            value={this.state.endTime}
            onChangeText={(value, index, data) => {
              this.handelOnSelectEndTime(value);
            }}
          ></Select>
        </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  rootStyle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  calenderStyle: {},
  timerStyle: {
    flexDirection: "row",
    paddingTop: 18,
    marginHorizontal: 1,
    flex: 1,
  },
});
export default DateAndTime;
